import * as yup from 'yup'
import Moment from 'moment'

type ParticipantSchema = {
  [key: string]: yup.Schema
}

export const fieldRequired = 'Dieses Feld ist zwingend erforderlich.'
const legalDate = 'Bitte geben Sie ein Datum im Format (D)D.(M)M.YYYY ein.'
const dateRegex = /^(0[1-9]|[12]\d|30|31)\.(0[1-9]|1[0-2])\.\d{4}$/

const checkAllowedRegex = function(value: string) {
  if (dateRegex.test(value)) return value
  else if (/^([1-9])\.(0[1-9]|1[0-2])\.\d{4}$/.test(value))
    return Moment(value, 'D.MM.YYYY').format('0D.MM.YYYY')
  else if (/^(0[1-9]|[12]\d|30|31)\.([1-9])\.\d{4}$/.test(value))
    return Moment(value, 'DD.M.YYYY').format('DD.0M.YYYY')
  else if (/^([1-9])\.([1-9])\.\d{4}$/.test(value))
    return Moment(value, 'D.M.YYYY').format('0D.0M.YYYY')
  else return value
}

export const mainSchema: ParticipantSchema = {
  first_name: yup.string().required(fieldRequired),
  last_name: yup.string().required(fieldRequired),
  legal_guardian: yup.string(),
  second_legal_guardian: yup.string(),
  gender: yup.string().required(fieldRequired),
  date_of_birth: yup
    .string()
    .transform(checkAllowedRegex)
    .matches(dateRegex, legalDate)
    .required(fieldRequired)
    .typeError('Bitte wählen Sie ein korrektes Datum aus.'),
  disabled: yup.boolean().notRequired(),
  handicap: yup.string().notRequired(),
  street: yup.string().required(fieldRequired),
  zip_code: yup
    .string()
    .matches(/^\d{5}$/, 'Die PLZ muss aus fünf Zahlen bestehen.')
    .required(fieldRequired),
  city: yup.string().required(fieldRequired),
  district: yup.string(),
  phone: yup.string().required(fieldRequired),
  email: yup
    .string()
    .email('Dieses Feld erfordert eine korrekte E-Mail-Adresse.')
    .required(fieldRequired),
  email_repeat: yup
    .string()
    .email('Dieses Feld erfordert eine korrekte E-Mail-Adresse.')
    .oneOf(
      [yup.ref('email'), undefined],
      'Bitte geben Sie hier nochmal die identische E-Mail-Adresse ein.'
    )
    .required(fieldRequired),
  school: yup.string(),
  sending_post: yup.string().optional(), //.required(fieldRequired), //TODO: only require if feature is on
  access_key: yup.string(),
}

export const childSchema = {
  name: yup.string().required(fieldRequired),
  date_of_birth: yup
    .string()
    .transform(checkAllowedRegex)
    .matches(dateRegex, legalDate)
    .required(fieldRequired)
    .typeError('Bitte wählen Sie ein korrektes Datum aus.'),
  //gender: yup.string().required(fieldRequired), //TODO: this being required broke participant stage with family mode, we don't ask for gender?
  disabled: yup.boolean().notRequired(),
  handicap: yup.string().notRequired(), 
}